"use strict";

import 'core-js/features/promise';
import 'element-closest-polyfill';
import * as Yup from 'yup';
import axios from "axios";

class Slider5 {
    constructor(element) {
        this.element = document.querySelector(element);
    }
}

/**
 * Nice Select Plugin customized for Custom Questionnaire ( Solicitors => search, add solicitor if not exist )
 * TODO : cleanup jquery 😑
 */
class NiceSelect {

    constructor(select, isMulti) {

        // Check if the Element exist
        if (!select) {
            return;
        }

        // Hide native select
        select.style.display = 'none';

        // Initialization
        this.id = 'niceSelector-' + (Math.random() + 1).toString(36).substring(7);
        this.reference = '#' + this.id;
        this.noPhoto = '/assets/img/individual-solicitors/nophoto.png';

        this.isMulti = isMulti;
        this.list = [];
        this.selectedList = [];

        this.defaultText = select.getAttribute('rs-default-text');
        this.isLoaded = select.hasAttribute('rs-selected-list');
        this.isReserved = select.hasAttribute('rs-is-preserved') ? select.getAttribute('rs-is-preserved') === 'true' : false;

        // Build Selector, select the simple select of the solicitors select
        const HTML = this.isMulti
            ? '<input class="current search-input" type="text" placeholder="' + this.defaultText + '" ><ul class="nice-select-list list"></ul>'
            : '<span class="current"></span><ul class="nice-select-list list"></ul>';

        // Create the nice select dropdown
        const niceSelectDropdown = document.createElement('div');
        niceSelectDropdown.classList.add('nice-select');
        niceSelectDropdown.setAttribute('id', this.id)
        niceSelectDropdown.innerHTML = HTML;
        niceSelectDropdown.addEventListener('click', () => {
            if (niceSelectDropdown.classList.contains('open')) {
                niceSelectDropdown.blur();
                niceSelectDropdown.classList.remove('open');
                if (this.isMulti) {
                    const searchInput = niceSelectDropdown.querySelector('.current')
                    searchInput.value = '';
                    searchInput.blur();
                    this.renderList(this.list);
                }
            } else {
                niceSelectDropdown.classList.add('open');
                niceSelectDropdown.querySelector('.focus')?.classList.remove('focus');
                niceSelectDropdown.querySelector('.selected')?.classList.add('focus');
                if(this.isMulti) {
                    let $dropdown = $(niceSelectDropdown);
                    let $focused_option = $dropdown.find('li.option.focus')[0]
                        ? $dropdown.find('li.option.focus')[0]
                        : $dropdown.find('li.option:nth-of-type(1)')[0];
                    $focused_option.classList.add('focus');
                }
            }
        });
        select.after(niceSelectDropdown);

        const niceSelectDropdownList = niceSelectDropdown.querySelector('.nice-select-list');
        const options = select.querySelectorAll('option');
        const idList = select.getAttribute('rs-selected-list')?.split(',') ?? [];
        // First element
        niceSelectDropdown.querySelector('.current').innerHTML = options[0]?.innerText;

        options.forEach((option, index) => {

            if (index === 0 && !this.isMulti) {
                return
            }

            const content = this.isMulti
                ? `<img src="${option.getAttribute('data-profile-image')}"  alt="${option.innerText}" class="cq__solicitor-profile cq__solicitor-profile--option"><span class="cq__solicitor-profile-text">${option.innerText}</span>`
                : option.innerText;

            // Create the object from the option
            let itemObject = this.createOptionItemObject(
                option.value,
                option.innerText,
                option.getAttribute('data-profile-image'),
                false
            );

            // Check if is preserved
            if (this.isLoaded) {
                if (idList.indexOf(option.value) > -1) {
                    if(this.isMulti) {
                        itemObject.isReserved = this.isReserved;
                        this.selectedList.push(itemObject);
                        this.renderSelectedList();

                    }
                }
            }

            if(!this.isMulti && option.hasAttribute('selected') && option.getAttribute('selected') === 'selected') {
                niceSelectDropdown.querySelector('.current').innerHTML = option.innerText;
            }

            // Fill the list
            this.list.push(itemObject);

            if (this.selectedList.findIndex( i => i.id === option.value) === -1) {
                const item = document.createElement('li');
                item.classList.add('option');
                item.classList.add('option--solicitor');
                item.setAttribute('data-value', option.value)
                item.setAttribute('data-title', option.innerText)
                item.setAttribute('data-photo', option.getAttribute('data-profile-image'))
                item.innerHTML = content;
                item.addEventListener('click', () => this.selectOption(item));
                niceSelectDropdownList.append(item);
            }

            // Render at the last iteration
            if(index === (options.length - 1))
            {
                // Add pre-selected external solicitor
                if(this.isLoaded && this.isMulti) {
                    const externalSolicitors = idList.filter(e => isNaN(parseInt(e))) ?? [];
                    externalSolicitors.forEach(s => {
                        this.selectedList.push(this.createOptionItemObject(s, s, this.noPhoto, this.isReserved));
                        this.renderSelectedList();
                    })
                }
            }
        });

        // Search input
        const searchInput = document.querySelector(this.reference + ' .search-input')
        if (searchInput) {
            searchInput.addEventListener('keyup', el => {

                if(el.keyCode === 32
                    || el.keyCode === 13
                    || el.keyCode === 37
                    || el.keyCode === 38
                    || el.keyCode === 39
                    || el.keyCode === 40) {
                    return;
                }

                let value = searchInput.value;
                let filter = value.toUpperCase();
                let index = 0;
                const filteredList = this.list.filter(item => item.title.toUpperCase().indexOf(filter) > -1);

                if (filteredList.length === 0) {
                    this.renderList([{
                        id: value,
                        title: value,
                        photo: this.noPhoto,
                        isReserved: false
                    }])
                } else {
                    this.renderList(filteredList);
                }

            })
        }

        // Close when clicking outside
        // TODO : not working ?
        document.addEventListener('click', (event) => {
            let element = event.target.closest(this.reference);
            if (element == null) {
                niceSelectDropdown.classList.remove('open');
            }
        })

        // Keyboard events
        $(document).on('keydown', this.reference, function (event) {

            let $dropdown = $(niceSelectDropdown);
            let $focused_option = $dropdown.find('li.option.focus')[0]
                ? $dropdown.find('li.option.focus')[0]
                : $dropdown.find('li.option:nth-of-type(1)')[0];

            // Space or Enter
            if (event.keyCode === 32 || event.keyCode === 13) {
                if ($dropdown.hasClass('open')) {
                    $($focused_option).trigger('click');
                }
                return false;
                // Down
            } else if (event.keyCode === 40) {
                if (!$dropdown.hasClass('open')) {
                    $dropdown.trigger('click');
                } else {
                    const $next = $($focused_option).nextAll('.option:not(.disabled)').first();
                    if ($next.length > 0) {
                        $dropdown.find('.focus').removeClass('focus');
                        $next.addClass('focus');
                    }
                }
                return false;

            } else if (event.keyCode === 38) {
                if (!$dropdown.hasClass('open')) {
                    $dropdown.trigger('click');
                } else {
                    const $next = $($focused_option).prevAll('.option:not(.disabled)').first();
                    if ($next.length > 0) {
                        $dropdown.find('.focus').removeClass('focus');
                        $next.addClass('focus');
                    }
                }
                return false;

            } else if (event.keyCode === 27) {
                if ($dropdown.hasClass('open')) {
                    $dropdown.trigger('click');
                }
            } else if (event.keyCode === 9) {
                if ($dropdown.hasClass('open')) {
                    return false;
                }
            }
        });
    }

    createOptionItemObject(id, title, photo, isReserved) {
        return {
            id: id,
            title: title,
            photo: photo,
            isReserved : isReserved
        }
    }

    selectOption(element) {
        const dropdown = document.querySelector(this.reference);
        const select = dropdown.previousElementSibling;

        dropdown.querySelector('.selected')?.classList.remove('selected');
        element.classList.add('selected');

        let text = element.innerText;

        if (this.isMulti) {
            if (this.selectedList.findIndex(item => item.id === element.getAttribute('data-value')) === -1) {
                this.selectedList.push({
                    id: element.getAttribute('data-value'),
                    title: element.getAttribute('data-title'),
                    photo: element.getAttribute('data-photo'),
                    isReserved: false
                });
            }

            dropdown.querySelector('.current').value = '';
            this.renderSelectedList();
            this.renderList(this.list);
        } else {
            dropdown.querySelector('.current').innerHTML = text;
            select.value = element.getAttribute('data-value');
            select.dispatchEvent(new CustomEvent('change'));
        }
    }

    renderList(list) {
        const dropdownList = document.getElementById(this.id).querySelector('.nice-select-list');
        dropdownList.innerHTML = '';

        list.forEach((item, index) => {
            if (this.selectedList.findIndex(i => i.id === item.id) === -1) {

                const content = this.isMulti
                    ? `<img src="${item?.photo}"  alt="${item.title}" class="cq__solicitor-profile cq__solicitor-profile--option"><span class="cq__solicitor-profile-text">${item.title}</span>`
                    : item.title;

                let listItem = document.createElement('li');
                listItem.setAttribute('data-value', item.id)
                listItem.setAttribute('data-title', item.title)
                listItem.setAttribute('data-photo', item.photo)
                listItem.classList.add('option');
                listItem.classList.add('option--solicitor');

                if(this.isMulti && index === 0) {
                    listItem.classList.add('focus');
                }

                listItem.innerHTML = content;
                listItem.addEventListener('click', () => this.selectOption(listItem));

                dropdownList.append(listItem);

            }
        })
    };

    renderSelectedList() {

        let contentForm = '';
        let contentSidebar = '';

        this.selectedList.forEach((element, index) => {
            contentForm += `<li class="cq__solicitors-list-item" data-index="${index}" data-target="${this.reference}"><img src="${element.photo}" alt="${element.title}" class="cq__solicitor-profile cq__solicitor-profile--option"><span class="cq__solicitor-profile-text">${element.title}</span>`;
            contentForm += element.isReserved ? '' : `<button data-element="${element.id}" class="cq__solicitor-delete-btn"><img class="cq__solicitor-delete-btn-icon" src="/assets/img/custom-questionnaire/delete-solicitor.svg" alt="delete-icon"></button>`;
            contentForm += `<input type="hidden" name="solicitors[]" value="${element.id}"></li>`;

            contentSidebar += `<li class="cq__solicitors-list-item" data-index="${index}" data-target="${this.reference}"><img src="${element.photo}" alt="${element.title}" class="cq__solicitor-profile cq__solicitor-profile--option"><span class="cq__solicitor-profile-text">${element.title}</span>`;
            contentSidebar += element.isReserved ? '' : `<button data-element="${element.id}" class="cq__solicitor-delete-btn"><img class="cq__solicitor-delete-btn-icon" src="/assets/img/custom-questionnaire/delete-solicitor.svg" alt="delete-icon"></button>`;
            contentSidebar += `</li>`;
        });

        document.querySelector('ul.cq__solicitors-list.cq__solicitors-list--form').innerHTML = contentForm;
        document.querySelector('ul.cq__solicitors-list.cq__solicitors-list--sidebar').innerHTML = contentSidebar;
        document.querySelector('div.cq__sidebar-your-solicitors-container').style.display = this.selectedList.length > 0
            ? 'block'
            : 'none';

        $(document).on('click', '.cq__solicitor-delete-btn', (el) => {
            const element = el.target.closest('button.cq__solicitor-delete-btn');
            let id = element.getAttribute('data-element');
            this.selectedList = this.selectedList.filter(el => el.id !== id);
            this.renderSelectedList();
        })

    };

}

/**
 * Set up star rating System
 */
class StarRating {
    constructor(selector) {
        this.ratingContainer = typeof selector === 'string' ?  document.querySelector(selector) : selector;

        if (this.ratingContainer == null) {
            return;
        }
        this.quickfireWords = [...this.ratingContainer.querySelectorAll('.cq__rating-quickfire-word')];
        this.userRating = this.ratingContainer.querySelector('input[type="hidden"]');

        if (this.ratingContainer !== null) {
            this.rating = 0;

            this.stars = [...this.ratingContainer.querySelectorAll('.cq__rating-star')].reverse();
            this.stars.forEach((star) => star.addEventListener('click', this.setStarRating));

            this.stars.forEach((star) => star.classList.remove('cq__rating-star--full'));
            this.stars.forEach((star, index) => index < this.rating && star.classList.add('cq__rating-star--full'));
        }
    }

    setStarRating = (e) => {
        this.rating = parseInt(e.target.closest('.cq__label--checkbox').previousElementSibling.value);
        this.stars.forEach((star) => star.classList.remove('cq__rating-star--full'));
        this.stars.forEach((star, index) => index < this.rating && star.classList.add('cq__rating-star--full'));

        if (this.ratingContainer.nextElementSibling.classList.contains('cq__validation-error--visible')) {
            this.ratingContainer.nextElementSibling.classList.remove('cq__validation-error--visible')
        }

        // Because of split questionnaires we need to do this to avoid console errors, also check we're specifically on the overall rating
        if (document.getElementById('wordCloudPositive') !== null) {
            if (this.rating > 2) {
                document.getElementById('wordCloudPositive').classList.remove('cq__form-control--checkbox-radio--hidden');
                document.getElementById('wordCloudNegative').classList.add('cq__form-control--checkbox-radio--hidden');
            } else {
                document.getElementById('wordCloudNegative').classList.remove('cq__form-control--checkbox-radio--hidden');
                document.getElementById('wordCloudPositive').classList.add('cq__form-control--checkbox-radio--hidden');
            }
        }

        if (this.quickfireWords) {
            this.quickfireWords.forEach((word) => word.classList.remove('cq__rating-quickfire-word--visible'));
            this.quickfireWords[this.rating - 1].classList.add('cq__rating-quickfire-word--visible');
        }

        this.userRating.value = this.rating;
    }
}

/**
 * Initialization
 */
(() => {
    // TODO : Only JS
    $('.cq__sidebar-your-solicitors-display-name-info-icon').on('click', () => {
        $('.cq__sidebar-your-solicitors-display-name-info-panel').toggleClass('cq__sidebar-your-solicitors-display-name-info-panel--open');
    });
    $('.cq__sidebar-your-solicitors-display-name-info-panel-close').on('click', () => {
        $('.cq__sidebar-your-solicitors-display-name-info-panel').toggleClass('cq__sidebar-your-solicitors-display-name-info-panel--open');
    });

    $(document).ready(() => {
        $('#caseDate').datepicker({
            dateFormat: "dd/mm/yy"
        });

        const overallRating = document.querySelector('input[name="rating"]:checked') && document.querySelector('input[name="rating"]:checked').value;
        if (overallRating) {
            document.querySelector('#rating').value = overallRating;
        }
    });

})();

/**
 * Apply Nice Select
 */
(() => {

    // Solicitor
    const solicitorSelect = document.querySelector('#solicitorSelect');
    if (solicitorSelect) {
        const solicitorNiceSelect = new NiceSelect(solicitorSelect, true);

        // Add more Solicitor
        const addMoreSolicitorButton = document.querySelector('#add-more-solicitor');
        if (addMoreSolicitorButton) {

            let textMore = addMoreSolicitorButton.getAttribute('data-text-more');
            let textClear = addMoreSolicitorButton.getAttribute('data-text-clear');
            let isDisplayed = false;

            addMoreSolicitorButton.addEventListener('click', () => {
                isDisplayed = !isDisplayed;
                document.querySelector('#solicitorSelect').closest('.cq__fieldset').style.display = isDisplayed ? 'flex' : 'none';
                addMoreSolicitorButton.innerHTML = isDisplayed ? textClear : textMore;
                if (!isDisplayed) {
                    solicitorNiceSelect.selectedList = [solicitorNiceSelect.selectedList[0]];
                    solicitorNiceSelect.renderSelectedList();
                }
            })
        }
    }

    // Other Select
    new NiceSelect(document.querySelector('#select-branch'), false);
    new NiceSelect(document.querySelector('#expectedToPay'), false);
    new NiceSelect(document.querySelector('#endedUpPaying'), false);
    new NiceSelect(document.querySelector('#checkClient'), false);

})();

/**
 * Apply Star rating
 */
(() => {

    const starRatingInputs = [
        '.cq__rating-stars--rating',
        '.cq__rating-stars--initial-impressions',
        '.cq__rating-stars--legal-knowledge',
        '.cq__rating-stars--approachability',
        '.cq__rating-stars--documentation-accuracy',
        '.cq__rating-stars--communication',
    ];

    starRatingInputs.forEach((starRating) => new StarRating(starRating));
    $('.cq__rating-stars--custom').get().forEach((starRating) => new StarRating(starRating));

})();

/**
 * Handle Language Selector
 */
(() => {
    // Initialization
    const button = document.getElementsByClassName('cq__language-selector-btn')[0];
    const buttonCloseList = document.getElementsByClassName('cq__header-inner-language-list-close-btn-icon');
    const languageDropdown = document.getElementsByClassName('cq__header-inner-language-list-container')[0];
    const languageDropdownItems = document.getElementsByClassName('cq__header-inner-language-list-item');

    // Dropdown Toggle
    button.addEventListener('click', () => {
        languageDropdown.classList.toggle('cq__header-inner-language-list-container--open');
    })
    // Dropdown close button
    buttonCloseList.forEach(el => {
        el.addEventListener('click', () => {
            languageDropdown.classList.toggle('cq__header-inner-language-list-container--open');
        })
    })
    // Dropdown Items Click event, change the language
    languageDropdownItems.forEach(languageItem => {
        languageItem.addEventListener('click', () => {
            let code = languageItem.getAttribute('data-code');
            // Build new URL and refresh the page
            const param = code === 'EN' ? '' : '&lang=' + code;
            let newUri = updateQueryParam(window.location.href, 'lang', code);
            if (code === 'EN') {
                newUri = newUri.replace('&lang=EN', '');
            }
            window.location.href = newUri;
        })
    });
    // update or add query param by key,value
    const updateQueryParam = (uri, key, value) => {
        let re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
        let separator = uri.indexOf('?') !== -1 ? "&" : "?";
        return (uri.match(re))
            ? uri.replace(re, '$1' + key + "=" + value + '$2')
            : uri + separator + key + "=" + value;
    }
})();

/**
 * Question 4 of the pricing section should only be displayed if the amount selected in question 2
 * is higher than what the client initially put in question 1.
 */
(() => {

    const yesCheckbox = document.getElementById('additionalWork-yes');
    const noCheckbox = document.getElementById('additionalWork-no');

    const yesNoQuestion = yesCheckbox?.closest('.cq__fieldset');
    const expectedToPay = document.getElementById('expectedToPay');
    const endedUpPaying = document.getElementById('endedUpPaying');

    if (yesCheckbox && noCheckbox && yesNoQuestion && expectedToPay && endedUpPaying) {

        yesNoQuestion.style.display = 'none';

        const transTextToNumber = (value) => {
            if (!value) {
                return null;
            } else if (value.startsWith('Under')) {
                return +value.replace('Under £', '');
            } else if (value.endsWith('+')) {
                return +value.replaceAll('£', '').replaceAll(',', '').replaceAll('+', '');
            } else {
                return value.replaceAll('£', '').replaceAll(',', '').replaceAll(' ', '').split('-').reduce((a, b) => (+a) + (+b), 0) / 2;
            }
        }

        const toggleYesNoQuestion = () => {
            const expected = transTextToNumber(expectedToPay.value);
            const ended = transTextToNumber(endedUpPaying.value);

            yesNoQuestion.style.display = (expected !== null && ended !== null)
                ? ended > expected ? 'block' : 'none'
                : 'none';

            yesCheckbox.checked = false;
            noCheckbox.checked = false;
        }

        [expectedToPay, endedUpPaying].forEach((el) => {
            el.addEventListener('change', () => {
                toggleYesNoQuestion();
            })
        })

        toggleYesNoQuestion();
    }

})();

/**
 * User Display Name 😑
 * Setup display name editor in sidebar panel (case management systems)
 */
(() => {

    const anonymousCheckbox = document.getElementById('anonymous-review');
    const userDisplayName = document.getElementById('userDisplayName');
    const reviewerNameInput = document.getElementById('reviewerNameInput');
    const ANONYMOUS = 'Anonymous';
    let prevName = reviewerNameInput && reviewerNameInput.value || '';

    // Safe update the userDisplayName
    const setUserDisplayNameValue = (value) => {
        if (userDisplayName) {
            prevName = userDisplayName.value;
            userDisplayName.value = value;
        }
    }

    // Safe update the reviewerDisplayName
    const setReviewerDisplayNameValue = (value) => {
        if (reviewerNameInput) {
            prevName = reviewerNameInput.value;
            reviewerNameInput.value = value;
        }
    }

    if (anonymousCheckbox) {

        let isAnonymous = reviewerNameInput.value === ANONYMOUS;
        let reviewerNameInputDefault = isAnonymous ? '' : reviewerNameInput.value;

        if (isAnonymous) {
            reviewerNameInput.setAttribute('readonly', 'true');
            anonymousCheckbox.setAttribute('checked', 'true');
        }

        reviewerNameInput.addEventListener('input', (el) => {
            setUserDisplayNameValue(el.target.value);
            setReviewerDisplayNameValue(el.target.value);
        });
        if (userDisplayName)
            userDisplayName.addEventListener('input', (el) => setReviewerDisplayNameValue(el.target.value));
        setUserDisplayNameValue(isAnonymous ? ANONYMOUS : reviewerNameInput.value);

        anonymousCheckbox.addEventListener('change', () => {
            if (isAnonymous) {
                reviewerNameInput.value = prevName;
                setUserDisplayNameValue(prevName);
                isAnonymous = false;
                reviewerNameInput.removeAttribute('readonly');
            } else {
                reviewerNameInputDefault = reviewerNameInput.value;
                reviewerNameInput.value = ANONYMOUS;
                setUserDisplayNameValue(ANONYMOUS);
                isAnonymous = true;
                reviewerNameInput.setAttribute('readonly', 'true');
            }
        });
    }

})();

// Sliders - update slider 5 colour when sliders move:

document.querySelectorAll('.cq__input-slider-5').forEach((slider) => {
    const sliderInput = slider.querySelector('.cq__input-slider-5-range');
    const sliderNodes = slider.querySelector('.cq__input-slider-5-nodes');

    sliderInput.addEventListener('input', e => {
        slider.setAttribute('data-value', e.target.value);
    });

    sliderNodes.addEventListener('click', e => {
        const value = e.target.getAttribute('value') === 'No rating' ? "0" : e.target.getAttribute('value');
        sliderInput.value = value;
        slider.setAttribute('data-value', value);
    });
});

// Sliders - update slider 10 colour when sliders move:

document.querySelectorAll('.cq__input-slider-10').forEach((slider) => {
    const sliderInput = slider.querySelector('.cq__input-slider-10-range');
    const sliderNodes = slider.querySelector('.cq__input-slider-10-nodes');

    sliderInput.addEventListener('input', e => {
        slider.setAttribute('data-value', e.target.value);
    });

    sliderNodes.addEventListener('click', e => {
        const value = e.target.getAttribute('value') === 'No rating' ? "0" : e.target.getAttribute('value');
        sliderInput.value = value;
        slider.setAttribute('data-value', value);
    });
});

/**
 * Form Submit
 */
(() => {

    const userIsSignedIn = isSignedIn;

    const submitButton = document.getElementById("submitReviewButton");
    const rsSignUpModal = document.getElementById("signupModal");

    const rateYourExperienceStarRating = document.getElementById('rating');

    const reviewTitle = document.getElementById('title');
    if (reviewTitle) {
        reviewTitle.addEventListener('input', (e) => {
            if (e.target.value.length > 0 && reviewTitle.closest('.cq__fieldset').querySelector('.cq__validation-error').classList.contains('cq__validation-error--visible')) {
                reviewTitle.closest('.cq__fieldset').querySelector('.cq__validation-error').classList.remove('cq__validation-error--visible');
            }
        });
    }

    const shareYourExperienceText = document.getElementById('text');
    if (shareYourExperienceText) {
        shareYourExperienceText.addEventListener('input', (e) => {
            if (e.target.value.length >= 40 && shareYourExperienceText.closest('.cq__fieldset').querySelector('.cq__validation-error').classList.contains('cq__validation-error--visible')) {
                shareYourExperienceText.closest('.cq__fieldset').querySelector('.cq__validation-error').classList.remove('cq__validation-error--visible');
            }
        });
    }

    const displayName = document.getElementById('userDisplayName') && document.getElementById('userDisplayName').type === "hidden" ? null : document.getElementById('userDisplayName');
// const displayName = document.querySelector('input#userDisplayName')
    if (displayName) {
        displayName.addEventListener('input', (e) => {
            if (e.target.value.length > 0 && displayName.closest('.cq__fieldset').querySelector('.cq__validation-error').classList.contains('cq__validation-error--visible')) {
                displayName.closest('.cq__fieldset').querySelector('.cq__validation-error').classList.remove('cq__validation-error--visible');
            }
        });
    }

    const emailAddress = document.getElementById('userEmailAddress');
    if (emailAddress) {
        emailAddress.addEventListener('input', (e) => {
            if (e.target.value.length > 0 && emailAddress.closest('.cq__fieldset').querySelector('.cq__validation-error').classList.contains('cq__validation-error--visible')) {
                emailAddress.closest('.cq__fieldset').querySelector('.cq__validation-error').classList.remove('cq__validation-error--visible');
            }
        });
    }

    const satisfiedYes = document.getElementById('satisfied-yes');
    const satisfiedNo = document.getElementById('satisfied-no');
    let satisfiedResult = satisfiedYes && satisfiedYes.checked ? 'yes' : (satisfiedNo && satisfiedNo.checked ? 'no' : '');
    // Should always be shown together so safe to do this
    if (satisfiedYes && satisfiedNo) {
        [satisfiedYes, satisfiedNo].forEach((radioInput) => {
            radioInput.addEventListener('change', (e) => {
                satisfiedResult = e.target.value;
                if ((satisfiedResult === 'yes' || satisfiedResult === 'no') && satisfiedYes.parentElement.parentElement.nextElementSibling.classList.contains('cq__validation-error--visible')) {
                    satisfiedYes.parentElement.parentElement.nextElementSibling.classList.remove('cq__validation-error--visible');
                }
            })
        });
    }

    const recommendYes = document.getElementById('recommend-yes');
    const recommendNo = document.getElementById('recommend-no');
    let recommendResult = recommendYes && recommendYes.checked ? 'yes' : (recommendNo && recommendNo.checked ? 'no' : '');
    if (recommendYes && recommendNo) {
        [recommendYes, recommendNo].forEach((radioInput) => {
            radioInput.addEventListener('change', (e) => {
                recommendResult = e.target.value;
                if ((recommendResult === 'yes' || recommendResult === 'no') && recommendYes.parentElement.parentElement.nextElementSibling.classList.contains('cq__validation-error--visible')) {
                    recommendYes.parentElement.parentElement.nextElementSibling.classList.remove('cq__validation-error--visible');
                }
            })
        });
    }

    let clientExperienceResult = '';
    const clientExperienceSelect = document.querySelector('#checkClient');
    if (clientExperienceSelect) {
        clientExperienceSelect.addEventListener('change', () => {
            clientExperienceResult = clientExperienceSelect.value;
            if (clientExperienceSelect.selectedIndex > 0 && clientExperienceSelect.closest('.cq__fieldset').querySelector('.cq__validation-error').classList.contains('cq__validation-error--visible')) {
                clientExperienceSelect.closest('.cq__fieldset').querySelector('.cq__validation-error').classList.remove('cq__validation-error--visible');
            }
        }, false);
    }

    let acceptTermsResult1 = false;
    let acceptTermsResult2 = false;
    const acceptTermsCheckbox1 = document.querySelector('#submit-review-1');
    const acceptTermsCheckbox2 = document.querySelector('#submit-review-2');
    if (acceptTermsCheckbox1 && acceptTermsCheckbox2) {
        [acceptTermsCheckbox1, acceptTermsCheckbox2].forEach((el) => {
            el.addEventListener('change', () => {
                acceptTermsResult1 = acceptTermsCheckbox1.checked;
                acceptTermsResult2 = acceptTermsCheckbox2.checked;

                if(acceptTermsResult1 && !acceptTermsResult2) {
                    acceptTermsCheckbox1.closest('.cq__fieldset').querySelector('.cq__validation-error.error-secondary').classList.remove('cq__validation-error--visible');
                    acceptTermsCheckbox1.closest('.cq__fieldset').querySelector('.cq__validation-error.error-primary').classList.add('cq__validation-error--visible');
                } else if (!acceptTermsResult1 && acceptTermsResult2) {
                    acceptTermsCheckbox1.closest('.cq__fieldset').querySelector('.cq__validation-error.error-primary').classList.remove('cq__validation-error--visible');
                    acceptTermsCheckbox1.closest('.cq__fieldset').querySelector('.cq__validation-error.error-secondary').classList.add('cq__validation-error--visible');
                } else if (acceptTermsResult1 && acceptTermsResult2) {
                    acceptTermsCheckbox1.closest('.cq__fieldset').querySelector('.cq__validation-error.error-secondary').classList.remove('cq__validation-error--visible');
                    acceptTermsCheckbox1.closest('.cq__fieldset').querySelector('.cq__validation-error.error-primary').classList.remove('cq__validation-error--visible');
                } else {
                    acceptTermsCheckbox1.closest('.cq__fieldset').querySelector('.cq__validation-error.error-secondary').classList.add('cq__validation-error--visible');
                    acceptTermsCheckbox1.closest('.cq__fieldset').querySelector('.cq__validation-error.error-primary').classList.remove('cq__validation-error--visible');
                }

            });
        })
    }

    const formFields = [
        rateYourExperienceStarRating,
        reviewTitle,
        shareYourExperienceText,
        satisfiedYes,
        recommendYes,
        clientExperienceSelect,
        acceptTermsCheckbox1,
        acceptTermsCheckbox2,
        displayName,
        emailAddress,
    ];

    let handleFormErrors = {
        'rateYourExperienceStarRating is a required field': () => rateYourExperienceStarRating && rateYourExperienceStarRating.closest('.cq__fieldset').querySelector('.cq__validation-error').classList.add('cq__validation-error--visible'),
        'reviewTitle is a required field': () => reviewTitle && reviewTitle.closest('.cq__fieldset').querySelector('.cq__validation-error').classList.add('cq__validation-error--visible'),
        'shareYourExperienceText is a required field': () => shareYourExperienceText && shareYourExperienceText.closest('.cq__fieldset').querySelector('.cq__validation-error').classList.add('cq__validation-error--visible'),
        'shareYourExperienceText must be at least 40 characters': () => shareYourExperienceText && shareYourExperienceText.closest('.cq__fieldset').querySelector('.cq__validation-error').classList.add('cq__validation-error--visible'),
        'displayName must be at least 1 characters': () => displayName && displayName.closest('.cq__fieldset').querySelector('.cq__validation-error').classList.add('cq__validation-error--visible'),
        'displayName is a required field': () => displayName && displayName.closest('.cq__fieldset').querySelector('.cq__validation-error').classList.add('cq__validation-error--visible'),
        'emailAddress must be a valid email': () => emailAddress && emailAddress.closest('.cq__fieldset').querySelector('.cq__validation-error').classList.add('cq__validation-error--visible'),
        'emailAddress is a required field': () => emailAddress && emailAddress.closest('.cq__fieldset').querySelector('.cq__validation-error').classList.add('cq__validation-error--visible'),
        'satisfied is a required field': () => satisfiedYes && satisfiedYes.closest('.cq__fieldset').querySelector('.cq__validation-error').classList.add('cq__validation-error--visible'),
        'satisfied must be one of the following values: yes, no': () => satisfiedYes && satisfiedYes.closest('.cq__fieldset').querySelector('.cq__validation-error').classList.add('cq__validation-error--visible'),
        'recommend is a required field': () => recommendYes && recommendYes.closest('.cq__fieldset').querySelector('.cq__validation-error').classList.add('cq__validation-error--visible'),
        'recommend must be one of the following values: yes, no': () => recommendYes && recommendYes.closest('.cq__fieldset').querySelector('.cq__validation-error').classList.add('cq__validation-error--visible'),
        'clientExperience is a required field': () => clientExperienceSelect && clientExperienceSelect.closest('.cq__fieldset').querySelector('.cq__validation-error').classList.add('cq__validation-error--visible'),
        'clientExperience must not be one of the following values: Please select an option': () => clientExperienceSelect && clientExperienceSelect.closest('.cq__fieldset').querySelector('.cq__validation-error').classList.add('cq__validation-error--visible'),
        'acceptTerms is a required field': () => {

            let acceptTermsResult1 = acceptTermsCheckbox1.checked;
            let acceptTermsResult2 = acceptTermsCheckbox2.checked;

            if(!acceptTermsResult1 && acceptTermsResult2) {
                acceptTermsCheckbox1.closest('.cq__fieldset').querySelector('.cq__validation-error.error-secondary').classList.add('cq__validation-error--visible')
            } else if (acceptTermsResult1 && !acceptTermsResult2) {
                acceptTermsCheckbox1.closest('.cq__fieldset').querySelector('.cq__validation-error.error-primary').classList.add('cq__validation-error--visible')
            } else if (!acceptTermsResult1 && !acceptTermsResult2) {
                acceptTermsCheckbox1.closest('.cq__fieldset').querySelector('.cq__validation-error.error-secondary').classList.add('cq__validation-error--visible')
            }
        },
        'acceptTerms must be one of the following values: true': () => {

            let acceptTermsResult1 = acceptTermsCheckbox1.checked;
            let acceptTermsResult2 = acceptTermsCheckbox2.checked;

            if(!acceptTermsResult1 && acceptTermsResult2) {
                acceptTermsCheckbox1.closest('.cq__fieldset').querySelector('.cq__validation-error.error-secondary').classList.add('cq__validation-error--visible')
            } else if (acceptTermsResult1 && !acceptTermsResult2) {
                acceptTermsCheckbox1.closest('.cq__fieldset').querySelector('.cq__validation-error.error-primary').classList.add('cq__validation-error--visible')
            } else if (!acceptTermsResult1 && !acceptTermsResult2) {
                acceptTermsCheckbox1.closest('.cq__fieldset').querySelector('.cq__validation-error.error-secondary').classList.add('cq__validation-error--visible')
            }
        },
    };

    //  CUSTOM : Find all custom questions
    const customMultilineFreeTextFields = Array.from(document.querySelectorAll('textarea[name="custom"]')).filter(element => element.required);
    const customSliderFields = $("input[name*='custom['][type='range']").get().filter(element => element.required);
    const customYesNoFields = $("input[name*='custom['][type='radio'][value='yes']").get().map(element => element.closest('.cq__fieldset.required')).filter(e => e !== null);
    const customRatingFields = $(".cq__rating-stars--custom input[type='hidden']").get().filter(element => element.required);
    const customCheckboxOrRadioFields = [...new Set([
        ...$(".cq__fieldset > div.cq__checkbox-container > label > input[name*='custom['][type='radio']").get().map(element => element.closest('.cq__fieldset.required')).filter(e => e !== null),
        ...$(".cq__fieldset > div.cq__checkbox-container > label > input[name*='custom['][type='checkbox']").get().map(element => element.closest('.cq__fieldset.required')).filter(e => e !== null)
    ])];

    const recommend = document.getElementById('recommend');
    if(recommend) {
        customSliderFields.push(recommend);
    }

    //  CUSTOM : Add custom input to Yup error message
    customMultilineFreeTextFields.forEach(customElement => {
        customElement.addEventListener('input', (e) => {
            if (e.target.value.length > 0 && customElement.closest('.cq__fieldset').querySelector('.cq__validation-error').classList.contains('cq__validation-error--visible')) {
                customElement.closest('.cq__fieldset').querySelector('.cq__validation-error').classList.remove('cq__validation-error--visible');
            }
        });
        const key = customElement.getAttribute('id').replace('[', '_').replace(']','');
        handleFormErrors[key + ' is a required field'] = () => customElement && customElement.closest('.cq__fieldset').querySelector('.cq__validation-error').classList.add('cq__validation-error--visible');
    })
    customSliderFields.forEach(customElement => {
        customElement.addEventListener('change', (e) => {
            if (customElement.closest('.cq__fieldset').querySelector('.cq__validation-error').classList.contains('cq__validation-error--visible')) {
                customElement.closest('.cq__fieldset').querySelector('.cq__validation-error').classList.remove('cq__validation-error--visible');
            }
        })
        const key = customElement.getAttribute('id').replace('[', '_').replace(']','');
        handleFormErrors[key + ' must not be one of the following values: 0'] = () => customElement && customElement.closest('.cq__fieldset').querySelector('.cq__validation-error').classList.add('cq__validation-error--visible');
    })
    customRatingFields.forEach(customElement => {
        customElement.addEventListener('change', (e) => {
            if (customElement.closest('.cq__fieldset').querySelector('.cq__validation-error').classList.contains('cq__validation-error--visible')) {
                customElement.closest('.cq__fieldset').querySelector('.cq__validation-error').classList.remove('cq__validation-error--visible');
            }
        })
        const key = customElement.getAttribute('id').replace('[', '_').replace(']','');
        handleFormErrors[key + ' is a required field'] = () => customElement && customElement.closest('.cq__fieldset').querySelector('.cq__validation-error').classList.add('cq__validation-error--visible');
    })
    customYesNoFields.forEach(customElement => {
        const yesElement = customElement.querySelector('input[value="yes"]');
        const noElement = customElement.querySelector('input[value="no"]');
        [yesElement, noElement].forEach((radioInput) => {
            radioInput.addEventListener('change', (e) => {
                if ((e.target.value === 'yes' || e.target.value === 'no') && customElement.querySelector('.cq__validation-error').classList.contains('cq__validation-error--visible')) {
                    customElement.querySelector('.cq__validation-error').classList.remove('cq__validation-error--visible');
                }
            })
        });

        handleFormErrors[yesElement.getAttribute('id') + ' is a required field'] = () => customElement.querySelector('.cq__validation-error').classList.add('cq__validation-error--visible');
        handleFormErrors[yesElement.getAttribute('id') + ' must be one of the following values: yes, no'] = () => customElement.querySelector('.cq__validation-error').classList.add('cq__validation-error--visible');
    })
    customCheckboxOrRadioFields.forEach(customElement => {
        const firstElement = customElement.querySelector("input");
        const elements =  Array.from(customElement.querySelectorAll("input"));
        const values = elements.map(e => e.value);
        elements.forEach((input) => {
            input.addEventListener('change', (e) => {
                if ((values.includes(e.target.value)) && customElement.querySelector('.cq__validation-error').classList.contains('cq__validation-error--visible')) {
                    customElement.querySelector('.cq__validation-error').classList.remove('cq__validation-error--visible');
                }
            })
        });
        handleFormErrors[firstElement.getAttribute('id') + ' is a required field'] = () => customElement.querySelector('.cq__validation-error').classList.add('cq__validation-error--visible');
        handleFormErrors[firstElement.getAttribute('id') + ' must be one of the following values: ' + [...new Set(values)].toString().replaceAll(',', ', ') ] = () => customElement.querySelector('.cq__validation-error').classList.add('cq__validation-error--visible');
    })

    const validateFormData = () => {

        let schema = {
            rateYourExperienceStarRating: rateYourExperienceStarRating && Yup.string().required(),
            reviewTitle: reviewTitle && Yup.string().required(),
            shareYourExperienceText: shareYourExperienceText && Yup.string().min(40).required(),
            satisfied: satisfiedYes && Yup.string().oneOf(['yes', 'no']).required(),
            recommend: recommendYes && Yup.string().oneOf(['yes', 'no']).required(),
            clientExperience: clientExperienceSelect && Yup.string().notOneOf(['Please select an option']).required(),
            acceptTerms: acceptTermsCheckbox1 && acceptTermsCheckbox2 && Yup.boolean().oneOf([true]).required(),
            displayName: displayName && Yup.string().min(1).required(),
            emailAddress: emailAddress && Yup.string().email().required()
        };

        //  CUSTOM : Add custom input to Yup schema
        [...customMultilineFreeTextFields, ...customRatingFields].forEach(customElement => {
            const key = customElement.getAttribute('id').replace('[', '_').replace(']','');
            schema[key] = Yup.string().required();
        });
        customSliderFields.forEach(customElement => {
            const key = customElement.getAttribute('id').replace('[', '_').replace(']','');
            schema[key] = Yup.string().notOneOf(['0']).required();
        });
        customYesNoFields.forEach(customElement => {
            const yesElement = customElement.querySelector('input[value="yes"]');
            schema[yesElement.getAttribute('id')] = Yup.string().oneOf(['yes', 'no']).required();
        });
        customCheckboxOrRadioFields.forEach(customElement => {
            const firstElement = customElement.querySelector("input");
            const values = Array.from(customElement.querySelectorAll("input")).map(e => e.value);
            schema[firstElement.getAttribute('id')] = Yup.string().oneOf(values).required();
        });

        const formValidationSchema = Yup.object().shape(schema);
        return new Promise((resolve, reject) => {

            let validations = {
                rateYourExperienceStarRating: rateYourExperienceStarRating && rateYourExperienceStarRating.value,
                reviewTitle: reviewTitle && reviewTitle.value,
                shareYourExperienceText: shareYourExperienceText && shareYourExperienceText.value,
                satisfied: satisfiedResult,
                recommend: recommendResult,
                clientExperience: clientExperienceResult,
                acceptTerms: acceptTermsResult1 && acceptTermsResult2,
                displayName: displayName && displayName.value,
                emailAddress: emailAddress && emailAddress.value,
            };

            //  CUSTOM : Add custom input to Yup validation
            [...customMultilineFreeTextFields, ...customSliderFields, ...customRatingFields].forEach(customElement => {
                const key = customElement.getAttribute('id').replace('[', '_').replace(']','');
                validations[key] = customElement.value;
            })
            customYesNoFields.forEach(customElement => {
                const yesElement = customElement.querySelector('input[value="yes"]');
                const noElement = customElement.querySelector('input[value="no"]');
                validations[yesElement.getAttribute('id')] = yesElement && yesElement.checked ? 'yes' : (noElement && noElement.checked ? 'no' : '');
            })
            customCheckboxOrRadioFields.forEach(customElement => {
                const firstElement = customElement.querySelector("input");
                const values = Array.from(customElement.querySelectorAll("input")).filter(e => e.checked).map(e => e.value);
                validations[firstElement.getAttribute('id')] = values.length > 0 ? values[0] : '';
            });

            formValidationSchema.validate(validations, {abortEarly: false})
                .then((formData) => {
                    resolve(formData);
                })
                .catch((validationError) => {
                    reject(validationError);
                });
        });

    };

    const scrollToRemainingValidationErrors = () => {
        const fieldsRemainingWithValidationErrors = document.querySelectorAll('.cq__validation-error--visible');
        const firstValidationErrorFieldset = $(fieldsRemainingWithValidationErrors[0]).closest('.cq__fieldset')[0];

        $('html, body').animate({
            scrollTop: $(firstValidationErrorFieldset).offset().top
        }, 500);
    }

    const scrollToTop = () => {
        $('html, body').animate({
            scrollTop: 0,
        }, 500);
    }


    submitButton.addEventListener("click", (e) => {
        if (!userIsSignedIn) {
            e.preventDefault();
            /* Validate review form: */
            validateFormData()
                .then((formData) => {

                    // If validation is okay, check for any remaining swear words in defamatory content checker.
                    // Scroll to the top of the document to take user to edit the review title / review text fields:
                    const swearingError = document.querySelector('.review-text-error-swearing');
                    if (swearingError && swearingError.classList.contains('d-block')) {
                        scrollToTop();
                        return;
                    }

                    /* Assuming validation is okay, remove any remaining error messages then open the sign up modal: */
                    formFields.forEach((field) => {
                        if (field !== null)
                            field.closest('.cq__fieldset').querySelector('.cq__validation-error').classList.remove('cq__validation-error--visible');
                    });
                    //  CUSTOM : Remove custom input error message
                    [...customMultilineFreeTextFields, ...customSliderFields, ...customRatingFields].forEach(customElement => {
                        customElement.closest('.cq__fieldset').querySelector('.cq__validation-error').classList.remove('cq__validation-error--visible');
                    });
                    [...customYesNoFields, ...customCheckboxOrRadioFields].forEach(customElement => {
                        customElement.querySelector('.cq__validation-error').classList.remove('cq__validation-error--visible');
                    });

                    rsSignUpModal.classList.add("cq__modal--open");
                })
                .catch((validationError) => {
                    formFields.forEach((field) => {
                        if (field !== null) {
                            console.log(field)
                            field.closest('.cq__fieldset').querySelector('.cq__validation-error').classList.remove('cq__validation-error--visible')
                        }
                    });
                    //  CUSTOM : Remove custom input error message
                    [...customMultilineFreeTextFields, ...customSliderFields, ...customRatingFields].forEach(customElement => {
                        customElement.closest('.cq__fieldset').querySelector('.cq__validation-error').classList.remove('cq__validation-error--visible');
                    });
                    [...customYesNoFields, ...customCheckboxOrRadioFields].forEach(customElement => {
                        customElement.querySelector('.cq__validation-error').classList.remove('cq__validation-error--visible');
                    })

                    console.log('=========');
                    validationError.errors.forEach((error) => {
                        handleFormErrors[error]()
                    });

                    scrollToRemainingValidationErrors();
                });
        } else {
            // For now
            e.preventDefault();
            /* Validate review form: */
            validateFormData()
                .then((formData) => {

                    // If validation is okay, check for any remaining swear words in defamatory content checker.
                    // Scroll to the top of the document to take user to edit the review title / review text fields:
                    const swearingError = document.querySelector('.review-text-error-swearing');
                    if (swearingError && swearingError.classList.contains('d-block')) {
                        scrollToTop();
                        return;
                    }

                   document.getElementById('reviewForm').submit();
                })
                .catch((validationError) => {

                    formFields.forEach((field) => {
                        if (field !== null)
                            field.closest('.cq__fieldset').querySelector('.cq__validation-error').classList.remove('cq__validation-error--visible')
                    });
                    validationError.errors.forEach((error) => {
                        handleFormErrors[error]()
                    });
                    scrollToRemainingValidationErrors();
                });
        }
    });

    /**
     * Modal Form Handler submit amd validation
     */
    const modalSubmit = document.getElementById("modalPost");
    const firstName = document.querySelector('#first-name');
    const lastName = document.querySelector('#last-name');
    const email = document.querySelector('#email');
    const password = document.querySelector('#password');
    const modalFormFields = [firstName, lastName, email, password];
    const handleModalFormErrors = {
        'firstName must be at least 1 characters': () => firstName.nextElementSibling.classList.add('cq__validation-error--visible'),
        'firstName is a required field': () => firstName.nextElementSibling.classList.add('cq__validation-error--visible'),
        'lastName must be at least 1 characters': () => lastName.nextElementSibling.classList.add('cq__validation-error--visible'),
        'lastName is a required field': () => lastName.nextElementSibling.classList.add('cq__validation-error--visible'),
        'email is a required field': () => email.nextElementSibling.classList.add('cq__validation-error--visible'),
        'email must be a valid email': () => email.nextElementSibling.classList.add('cq__validation-error--visible'),
        'password is a required field': () => password.nextElementSibling.classList.add('cq__validation-error--visible'),
    };

    modalFormFields.forEach((field) => {
        field.addEventListener('input', (e) => {
            if (e.target.value.length > 0 && field.nextElementSibling.classList.contains('cq__validation-error--visible')) {
                field.nextElementSibling.classList.remove('cq__validation-error--visible');
            }
        });
    });

    const validateUserDetails = () => {

        const modalFormValidationSchema = Yup.object().shape({
            firstName: Yup.string().min(1).required(),
            lastName: Yup.string().min(1).required(),
            email: Yup.string().email().required(),
            password: Yup.string().required(),
        });

        return new Promise((resolve, reject) => {

            modalFormValidationSchema.validate({
                firstName: firstName.value,
                lastName: lastName.value,
                email: email.value,
                password: password.value,
            }, {abortEarly: false})
                .then((userDetails) => {
                    resolve(userDetails);
                })
                .catch((validationError) => {
                    reject(validationError);
                });

        });
    };

    /**
     * Submit PostReview Form, validate form with Yup if success save review
     */
    modalSubmit.addEventListener("click", (e) => {

        e.preventDefault();

        document.getElementById("hiddenFirstName").value = document.getElementById("first-name").value;
        document.getElementById("hiddenLastName").value = document.getElementById("last-name").value;
        document.getElementById("hiddenEmail").value = document.getElementById("email").value;
        document.getElementById("hiddenPassword").value = document.getElementById("password").value;
        document.getElementById("hiddenIsSignUp").value = 'true';
        document.getElementById('email-error').classList.remove('cq__validation-error--visible');

        /* Modal Form */
        validateUserDetails()
            .then((userDetails) => {
                axios.get('/write-review-validate-email/' + document.getElementById("email").value)
                    .then((res) => {
                        if(res.data.valide) {
                            modalFormFields.forEach((field) => field.nextElementSibling.classList.remove('cq__validation-error--visible'));
                            document.getElementById('email-error').classList.remove('cq__validation-error--visible')
                            // Submit the form:
                            document.getElementById("reviewForm").submit();
                        } else {
                            document.getElementById('email-error').classList.add('cq__validation-error--visible')
                        }
                    })
            })
            .catch((validationError) => {

                modalFormFields.forEach((field) => field.nextElementSibling.classList.remove('cq__validation-error--visible'));
                validationError.errors.forEach((error) => handleModalFormErrors[error]());
            });
    });

})();
